var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVector33(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7785 10.7221L9.45552 8.39911C11.193 6.0761 10.7202 2.78598 8.39721 1.04853C6.07661 -0.691319 2.78409 -0.216159 1.04664 2.10444C-0.690817 4.42745 -0.215657 7.71756 2.10494 9.45742C3.96959 10.8541 6.53257 10.8541 8.39721 9.45742L10.7202 11.7804C11.013 12.0732 11.4857 12.0732 11.7785 11.7804C12.0713 11.4876 12.0713 11.0149 11.7785 10.7221ZM5.27028 9.00865C3.20645 9.00865 1.53379 7.336 1.53379 5.27217C1.53379 3.20835 3.20885 1.53329 5.27268 1.53329C7.3365 1.53329 9.00916 3.20595 9.00916 5.26977C9.00916 7.3336 7.3341 9.00385 5.27268 9.00625L5.27028 9.00865Z",
    fill: "#234492"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector33);
export default __webpack_public_path__ + "static/media/Vector (33).329131b59222ece2eb1e5d420850136c.svg";
export { ForwardRef as ReactComponent };